import 'babel-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { ReduxAsyncConnect } from 'redux-connect';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';

import 'bootstrap/dist/css/bootstrap.css';
import './app.css';

import i18n from './i18n';
import routes from './routes';
import { scrollToTop } from './utils';
import configureStore from './configureStore';
import { initI18n } from './actions';

import 'moment/locale/ru';
import 'moment/locale/en-gb';
import 'moment/locale/th';
import 'moment/locale/es';
import 'moment/locale/it';
import 'moment/locale/de';
import 'moment/locale/fr';
import 'moment/locale/el';

const store = configureStore(browserHistory, window.__data);
initI18n(store.getState);
const history = syncHistoryWithStore(browserHistory, store);

function onRouterUpdate() {
  const pathname = this.props.history.getCurrentLocation().pathname;

  if (this.lastPathname !== pathname) {
    scrollToTop();
  }

  this.lastPathname = pathname;
}

const asyncRender = (props) => (
  <ReduxAsyncConnect
    {...props}
    helpers={{ shouldWait: false }}
  />
);

function init() {
  ReactDOM.render(
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <Router
          onUpdate={onRouterUpdate}
          history={history}
          routes={routes}
          render={asyncRender}
        />
      </Provider>
    </I18nextProvider>,
    document.getElementById('root')
  );
}

window.onunhandledrejection = function(err) {
  console.error('Unhandled Promise Rejection', err.reason);
};

init();



// WEBPACK FOOTER //
// ./src/index.js